import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authenticationApi } from "../containers/Authentication/service";
import { adminApi, internalService as adminInternalApi } from "../containers/Admin/services";
import { adminFeaturesReducer } from "../containers/Admin/features";
import { modalReducer as mpModalReducer } from "../containers/ManagementPortal/features";
import { commonReducer } from "./features";
import { managementPortalApi, pluginApi, pluginFeaturesApi } from "../containers/ManagementPortal/services";
import {
  trackingApi,
  reverseGeoCodingApi,
  vehicleRouteApi,
  formattedVehicleRouteApi,
  tripsTrackApi,
  tripsApi,
  eventsApi,
  rawDataApi,
  variablesApi,
  trackingVehicleApi,
} from "../containers/Tracking/services";
import { driverBehaviorApi } from "../containers/DriverBehavior/services";

export const store = configureStore({
  reducer: {
    [authenticationApi.reducerPath]: authenticationApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [managementPortalApi.reducerPath]: managementPortalApi.reducer,
    [trackingApi.reducerPath]: trackingApi.reducer,
    [reverseGeoCodingApi.reducerPath]: reverseGeoCodingApi.reducer,
    [adminInternalApi.reducerPath]: adminInternalApi.reducer,
    [vehicleRouteApi.reducerPath]: vehicleRouteApi.reducer,
    [formattedVehicleRouteApi.reducerPath]: formattedVehicleRouteApi.reducer,
    [tripsApi.reducerPath]: tripsApi.reducer,
    [trackingVehicleApi.reducerPath]: trackingVehicleApi.reducer,
    [tripsTrackApi.reducerPath]: tripsTrackApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    [rawDataApi.reducerPath]: rawDataApi.reducer,
    [variablesApi.reducerPath]: variablesApi.reducer,
    [pluginApi.reducerPath]: pluginApi.reducer,
    [pluginFeaturesApi.reducerPath]: pluginFeaturesApi.reducer,
    [driverBehaviorApi.reducerPath]: driverBehaviorApi.reducer,

    adminFeaturesReducer,
    mpModal: mpModalReducer,
    common: commonReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authenticationApi.middleware,
      adminApi.middleware,
      managementPortalApi.middleware,
      trackingApi.middleware,
      reverseGeoCodingApi.middleware,
      adminInternalApi.middleware,
      vehicleRouteApi.middleware,
      formattedVehicleRouteApi.middleware,
      tripsApi.middleware,
      trackingVehicleApi.middleware,
      tripsTrackApi.middleware,
      eventsApi.middleware,
      rawDataApi.middleware,
      variablesApi.middleware,
      pluginApi.middleware,
      pluginFeaturesApi.middleware,
      driverBehaviorApi.middleware
    ),
});

setupListeners(store.dispatch);
